import { create } from 'zustand';

interface UIStoreState {
  modalOpen: boolean;
  activeBreadCrumb: string | null | undefined;
  hideNavigationElements: boolean;
  openModal: () => void;
  closeModal: () => void;
  setModalOpen: (open: boolean) => void;
  setActiveBreadCrumb: (activeBreadCrumb: string | null | undefined) => void;
  setHideNavigationElements: (hide: boolean) => void;
}

export const useUIStore = create<UIStoreState>(set => ({
  modalOpen: false,
  activeBreadCrumb: null,
  hideNavigationElements: false,
  openModal: () => set({ modalOpen: true }),
  closeModal: () => set({ modalOpen: false }),
  setModalOpen: (open: boolean) => set({ modalOpen: open }),
  setActiveBreadCrumb: (activeBreadCrumb: string | null | undefined) => set({ activeBreadCrumb }),
  setHideNavigationElements: (hide: boolean) => set({ hideNavigationElements: hide }),
}));
